import { ReactComponent as PencilIcon } from '@basqet-dashboard/common/assets/icons/pencil.svg';
import { ReactComponent as TrashIcon } from '@basqet-dashboard/common/assets/icons/trash.svg';
import PropTypes from 'prop-types';
import React from 'react';

const PersonRow = ({ name, onEdit, onDelete, readOnly }) => (
  <div className="ownership-person-row">
    <span className="ownership-person-row__name">{name}</span>
    {!readOnly && (
      <div className="ownership-person-row__actions">
        <button
          type="button"
          className="ownership-person-row__edit-btn"
          onClick={onEdit}
          aria-label="Edit">
          <PencilIcon />
        </button>
        <button
          type="button"
          className="ownership-person-row__delete-btn"
          onClick={onDelete}
          aria-label="Remove">
          <TrashIcon />
        </button>
      </div>
    )}
  </div>
);

PersonRow.propTypes = {
  name: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};

export { PersonRow };
